import styled, { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import { Media } from '../../assets/Mixins.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

import { Strong as commonStrong } from '../../assets/Common/Strong.style';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

export const Box = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(535px, 1fr));
  grid-gap: 30px;

  ${Media.lg`
    grid-template-columns: 1fr;
    grid-gap: 20px;
  `}
`;

export const Item = styled.div`
  display: block;
  width: 100%;
`;

export const Panel = styled.div`
  display: flex;
  width: 100%;
  max-width: 535px;
  height: 100%;
  min-height: 400px;
  justify-content: center;
  padding: 15px;
  margin: auto;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};

  ${Media.lg`
    max-width: initial;
    min-height: initial;
  `}
`;

export const PanelInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  text-align: center;
`;

export const Titlebox = styled.div`
  display: flex;
  min-height: 66px;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  padding: 0 0 20px;
`;

export const Title = styled.h2`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 26px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  word-break: break-word;
  cursor: default;

  ${Media.lg`
    font-size: 20px;
  `}
`;

export const TitleDeco = styled.span`
  ${commonStrong}
  margin-left: 10px;
  color: ${(props) => props.theme.color};
`;

export const TitleButton = styled(RouterLink)`
  ${commonButton}
`;

export const TitleButtonIcon = styled.i``;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  gap: 10px;
  overflow: auto;
`;

export const Row = styled.div`
  display: block;
  width: 100%;

  ${(props) =>
    props.grow &&
    css`
      flex-grow: 1;
    `}
`;

export const SubPanels = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  gap: 20px;

  ${Media.sm`
    flex-direction: column;
  `}
`;

export const SubPanel = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  padding: 15px;
  margin: auto;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};

  ${(props) =>
    props.narrow &&
    css`
      padding: 8px 15px;
    `}
`;

export const SubPanelInner = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const SubPanelTitle = styled.div`
  display: inline-block;
  height: 50%;
  color: ${(props) => props.theme.color};
  font-size: 21px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  word-break: break-word;
  cursor: default;
`;

export const SubPanelValue = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 50%;
  height: 100%;
  color: ${(props) => props.theme.color};
  font-size: 65px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  /* word-break: break-word; */
  cursor: default;
`;

export const SubPanelInfo = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  gap: 15px;
  text-align: left;
`;

export const SubPanelInfoLabel = styled.div`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
  word-break: break-word;
  cursor: default;
`;

export const SubPanelInfoValue = styled.div`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
  word-break: break-word;
  cursor: default;
`;

export const AvatarHolder = styled.div`
  display: flex;
  width: 45px;
  height: 45px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  flex-shrink: 0;
  border: 2px solid ${(props) => props.theme.border};
  overflow: hidden;
`;

export const Avatar = styled.img`
  display: block;
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 15px;
  flex-shrink: 0;
  background: ${(props) => props.theme.background};
`;

export const AvatarPlaceholder = styled.div`
  display: block;
  width: 45px;
  height: 45px;
  object-fit: cover;
  border-radius: 15px;
  flex-shrink: 0;
  background: ${(props) => props.theme.background};
`;

export const Information = styled.span`
  display: block;
  width: 100%;
  color: ${(props) => props.theme.color};
  font-size: 16px;
  font-weight: 700;
`;

export const Table = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 5px;
`;

export const TableRow = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: ${(props) => props.gridTemplateColumns || '1fr'};
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};

  ${(props) =>
    props.head &&
    css`
      border-radius: 0;

      ${Media.sm`
        display: none;
      `}
    `}

  ${Media.sm`
    grid-template-columns: 1fr;
  `}
`;

export const TableCell = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 400;
  line-height: 1;
  text-align: left;
  word-break: break-word;
  cursor: default;

  ${(props) =>
    props.head &&
    css`
      padding: 10px 10px;
      border-radius: 0;
      font-weight: 700;
    `}

  ${(props) =>
    props.right &&
    css`
      justify-content: flex-end;
      ${Media.sm`
        justify-content: center;
      `}
    `}

  ${Media.sm`
    gap: 5px;
  `}
`;

export const Label = styled.span`
  width: 50%;
`;

export const Value = styled.span`
  width: 50%;
`;

export const Button = styled.button`
  ${commonButton}
`;

export const ButtonIcon = styled.i``;

export const Strong = styled.strong`
  ${commonStrong}
`;
